import React, { Suspense, useState, useEffect } from "react";
import { HashRouter } from "react-router-dom";
import styled from "styled-components";
import { browser, getParameterByName, pixel2vw } from "@/utils/utils";
import { connect } from "react-redux";
import { getUserInfo } from "@/actions/userInfo";
import { getPermissionList } from "@/actions/permission";
import { Spin } from "antd";
import { getEdit } from "@/actions/editGuidance";
import { getMessageSettingsOpen } from "@/actions/messageSettingsOpen";
import { getCrmPermission } from "@/actions/crmPermission";
import PcCheckPage from "./pc-check-page/guidance";
import { setGlobalConfig } from '@/actions/globalConfig'
import PreviewPage from "./preview-page";
import QrCodeView from '@/pages/qrcode-view/qrcode-view'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: ${pixel2vw(64)};
    height: ${pixel2vw(64)};
  }
`;

const mapDispatchToProps = {
  getUserInfo,
  getEdit,
  getPermissionList,
  getMessageSettingsOpen,
  getCrmPermission,
  setGlobalConfig
};

const mapStateToProps = (state) => {
  const { userInfo } = state;
  return { ...userInfo };
};

const Router = function () {
  const [menuType, setMenuType] = useState("main");
  const deviceType = getParameterByName("deviceType");
  const lxyUserToken = window.current_user_token;
  const isMobile = browser(window.navigator.userAgent) || deviceType === "h5Side";
  const activePath = window.location.hash.split("#")[1];
  const isPreview = activePath?.indexOf("/file-preview") !== -1 || activePath?.indexOf("/applet-share") !== -1;
  const isQrCodeView = activePath?.indexOf("/qr") !== -1

  // 设置菜单状态
  const changeMenu = (value) => {
    setMenuType(value);
  };

  useEffect(() => {
    localStorage.setItem("back-btn", 'false')
    window.getUserAndEnterPriseStart = new Date().valueOf()
  }, []);



  const errorCode = getParameterByName("errorCode");
  return (
    <HashRouter>
      <Suspense
        fallback={
          !isPreview && isMobile && lxyUserToken && !isQrCodeView
            ?
            <></>
            :
            <Wrapper>
              <Spin tip="加载中..." />
            </Wrapper>
        }
      >
        {isPreview && <PreviewPage />}
        {isQrCodeView && <QrCodeView />}
        {!isQrCodeView && !isPreview && !isMobile && lxyUserToken && (
          <PcCheckPage
            menuType={menuType}
            changeMenu={changeMenu}
            errorCode={errorCode}
          />
        )}
      </Suspense>
    </HashRouter>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Router);
